export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(n || 0);

export const fmtCompact = (n) =>
  new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(n || 0);

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.16, 1, 0.3, 1];

const img = (base, w) => `${base}&auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: img(
    "https://images.unsplash.com/photo-1694286068611-d0c24cbc2cd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHxfMTc5MTE1OTQ0OHww&ixlib=rb-4.1.0",
    1100
  ),
  foodRelief: img(
    "https://images.unsplash.com/photo-1628717341663-0007b0ee2597?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxNzkxMTU5NDU2fDA&ixlib=rb-4.1.0",
    1400
  ),
  education: img(
    "https://images.unsplash.com/photo-1649386525679-214da4fa6676?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxNzkxMTU5NDU2fDA&ixlib=rb-4.1.0",
    1000
  ),
  family: img(
    "https://images.unsplash.com/photo-1727475805926-b731fa90dee3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxNzkxMTU5NDQ5fDA&ixlib=rb-4.1.0",
    1000
  ),
  classroom: img(
    "https://images.unsplash.com/photo-1761208662734-fb46f1398551?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxNzkxMTU5NDU2fDA&ixlib=rb-4.1.0",
    1000
  ),
  volunteers: img(
    "https://images.unsplash.com/photo-1599059813005-11265ba4b4ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxNzkxMTU5NDU2fDA&ixlib=rb-4.1.0",
    1200
  ),
};
